<template>
  <btn
    v-bind="{
      ...$attrs,
      size,
    }"
    :btn-text="cancelText"
    :variant="variant"
    :data-cy="dataCy"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </btn>
</template>

<script>
  export default {
    name: 'CancelBtn',

    props: {
      dataCy: { type: String, default: 'cancel-btn' },
      variant: { type: String, default: 'outline-primary' },
      size: {
        type: String,
        default: 'md',
      },
      cancelText: {
        type: String,
        default: function () {
          return this.$t('cmrad.cancel');
        },
      },
    },

    data() {
      return {
        busy: false,
      };
    },

    methods: {
      onClick() {
        this.busy = true;
      },
    },
  };
</script>
